import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,      // 5分钟内数据视为新鲜
            gcTime: 30 * 60 * 1000,         // 30分钟后清空缓存
            refetchOnWindowFocus: false,    // 切回窗口不重新请求
        },
    },
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
            <React.StrictMode>
                <App/>
            </React.StrictMode>
            <ReactQueryDevtools initialIsOpen={false}/>
        </QueryClientProvider>
    </ErrorBoundary>
);
